import React, { useState, useEffect } from 'react';

import { createPortal } from 'react-dom';
import WorkflowViewDiagramModal from '@jira/project-settings__workflow-view-diagram-modal/src/WorkflowViewDiagramApp.tsx';
import { getDocument } from '@atlaskit/browser-apis';

const WORKFLOW_PREVIEW_PLACEHOLDER_ID = 'workflow-modern-preview-placeholder';

const AddExistingWorkflowPreview = (): React.JSX.Element => {
	const [selectedWorkflow, setSelectedWorkflow] = useState<string | undefined | null>(undefined);

	useEffect(() => {
		const observer = new MutationObserver(() => {
			const selectedWorkflowToPreview = getDocument()?.querySelector(
				'#add-workflow-dialog .project-config-workflow-add-dialog-list .selected',
			);

			if (selectedWorkflowToPreview) {
				const workflowName = selectedWorkflowToPreview.getAttribute('data-workflowname');
				setSelectedWorkflow(workflowName);
			} else {
				setSelectedWorkflow(undefined);
			}
		});

		const body = getDocument()?.body;
		if (body) observer.observe(body, { childList: true, subtree: true });

		return () => {
			observer && observer.disconnect();
		};
	}, []);

	const elm = getDocument()?.getElementById(WORKFLOW_PREVIEW_PLACEHOLDER_ID);
	return (
		<>
			{selectedWorkflow && elm
				? createPortal(
						<WorkflowViewDiagramModal workflowIdentifier={{ workflowName: selectedWorkflow }} />,
						elm,
					)
				: null}
		</>
	);
};

export default AddExistingWorkflowPreview;
